import { CreditCardOutlined } from "@ant-design/icons";
import { Tooltip } from "../ui";

export type AppShellLegalLink = {
  key: string;
  label: string;
  current?: boolean;
  /** Öffnet die Rechtsseite im App-Rahmen. */
  onClick: () => void;
};

export type AppShellNavigationFooterProps = {
  /** Tarifkarte: Tarifname (oder allgemeiner Titel) und Aufforderung darunter. */
  plan?: { title: string; meta: string; current?: boolean; onClick: () => void };
  /** Rechtstexte (AGB, Datenschutz, Impressum); der App-Rahmen zeigt sie im Benutzermenü, nicht im Fußbereich. */
  legal?: { label: string; links: AppShellLegalLink[] };
};

/**
 * Tarifkarte im Fußbereich der Navigation nach dem my-vitalteam-Rahmen. Eingeklappt nur das Tarifsymbol mit
 * Tooltip. Texte, Ziele und Rechte liefert das Produkt.
 */
export function AppShellNavigationFooter({ plan, compact }: AppShellNavigationFooterProps & { compact: boolean }) {
  const card = plan ? (
    <button type="button" className="mq-frame-plan" aria-current={plan.current ? "page" : undefined} aria-label={compact ? `${plan.title} – ${plan.meta}` : undefined} onClick={plan.onClick}>
      <span className="mq-frame-plan-icon" aria-hidden><CreditCardOutlined /></span>
      {compact ? null : (
        <span className="mq-frame-plan-text">
          <span className="mq-frame-plan-name">{plan.title}</span>
          <span className="mq-frame-plan-meta">{plan.meta}</span>
        </span>
      )}
    </button>
  ) : null;
  return compact && card && plan ? <Tooltip title={plan.title} placement="right">{card}</Tooltip> : card;
}
